<template>
  <list-table
    :url="url"
    title="تسویه های تسهیم"
    :fields="fields"
    :params="params"
    :detailUrl="detailUrl"
    :excelroute="'asdasd'"
    :btns="btns"
    @change="change"
  ></list-table>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { GET_BANK_LIST } from "@/core/services/store/getBankList.module";
import httpHelper from "../../helpers/httpHelper";
import TableShowData from "../../components/table";
import persianDate from "@/helpers/persianDate";
export default {
  name: "sharing",
  data() {
    return {
      url: "sharing",
      transactions_created_at: "",
      //anotherUrl:{SAD:'saderat/get-balance',SAM:'saman/deposit-balance'},
      params: [
        {
          label: "موجودی بانک سامان (ریال) :",
          field: "BalanceSaman",
          type: "text",
          value: "",
          disabled: true,
        },
        {
          label: "موجودی بانک سامان 2 (ریال) :",
          field: "BalanceSaman2",
          type: "text",
          value: "",
          disabled: true,
        },
        {
          label: "موجودی بانک صادرات (ریال) :",
          field: "BalanceSaderat",
          type: "text",
          value: "",
          disabled: true,
        },
        {
          label: "موجودی بانک ملی(ریال):",
          field: "BalanceMeli",
          type: "text",
          value: "",
          disabled: true,
        },
        {
          label: "موجودی بانک صادرات 4000 (ریال) :",
          field: "BalanceSaderat4000",
          type: "text",
          value: "",
          disabled: true,
        },
        {
          label: "از تاریخ :",
          field: "datefrom",
          type: "date-picker",
        },
        {
          label: "تا تاریخ:",
          field: "dateto",
          type: "date-picker",
        },
        {
          label: "وضعیت :",
          field: "status",
          type: "select",
          value: "failed",
          options: [],
        },
        {
          label: "نام بانک :",
          field: "bank_name",
          type: "text",
        },
        {
          label: "مبلغ (ریال) :",
          field: "amount",
          type: "number",
        },
      ],
      fields: [
        {
          key: "id",
          label: "کد درخواست",
        },
        {
          key: "website",
          label: "وب سایت",
        },
        {
          key: "amount",
          label: "مبلغ (ریال)",
          formatter(value, key, item) {
            return Number(value).toLocaleString();
          },
        },
        {
          key: "created_at",
          label: "تاریخ تسهیم",
          formatter: (value, key, item) => {
            return persianDate.getDate(value);
          },
        },
        {
          key: "transactions_created_at",
          label: "تاریخ تسویه",
          formatter: (value, key, item) => {
            if (item.saderat_transactions_created_at !== null) {
              return persianDate.getDate(item.saderat_transactions_created_at);
            } else if (item.saman_transactions_created_at !== null) {
              return persianDate.getDate(item.saman_transactions_created_at);
            } else {
              return "...";
            }
          },
        },
        {
          key: "status",
          label: "وضعیت",
          formatter: (value, key, item) => {
            if (item.parent_id === null) {
              return "تسویه نشده";
            } else if (
              item.transferStatus !== null &&
              item.transferStatus === "sent_to_core"
            ) {
              return "ارسال شده با ترنسفر جدید";
            } else if (
              item.transferStatus !== null &&
              item.transferStatus === "ready_to_transfer"
            ) {
              return "درخواست برای بانک ارسال شده";
            } else if (
              (item.transferStatus !== null &&
                item.transferStatus === "processed") ||
              (item.transaction_status !== null &&
                item.transaction_status === "success")
            ) {
              return "انجام شده";
            } else {
              return "لغو شده";
            }
          },
        },
        {
          key: "referenceId",
          label: "کد رهگیری",
          formatter: (value, key, item) => {
            if (item.referenceId !== null) {
              return item.referenceId;
            } else if (item.trace_number !== null) {
              return item.trace_number;
            } else {
              return "...";
            }
          },
        },
        {
          key: "bank_name",
          label: "نام بانک",
          formatter: (value, key, item) => {
            if (item.trace_number !== null) {
              return "صادرات";
            } else if (item.version === 1) {
              return "سامان 1";
            } else if (item.version === 2) {
              return "سامان 2";
            } else {
              return "...";
            }
          },
        },
        {
          key: "details",
          label: "جزییات",
        },
        {
          key: "btns",
          label: "حذف",
        },
      ],
      detailUrl: "SharingDetails",
      btns: [
        {
          icon: "trash-fill",
          title: "حذف",
          handler: (t) => {
              httpHelper.getData(`removeSharing/${t.doc_id}`).then((res) => {
                if (res.success) {
                  this.url = "sharing?t=" + new Date().getTime();
                  this.$makeToast(
                    "success",
                    "حذف موفق",
                    "رکورد مورد نظر با موفقیت حذف گردید.",
                    5000
                  );
                } else {
                  this.$makeToast(
                    "danger",
                    "خطا",
                    "خطای سمت سرور رخ داده است",
                    4000
                  );
                }
              });
          },
        },
      ],
    };
  },
  components: {
    "list-table": TableShowData,
  },
  computed: {},
  watch: {
    $route: {
      handler: function (search) {
        this.params[7].options = [];
        if(search.query?.status === "failed") {
          this.params[7].options.push({ text: "انجام نشده ها", value: search.query.status });
          this.params[7].value = search.query.status;
        } else if(search.query?.status === "corefailed") {
          this.params[7].options.push({ text: "ترنسفر جدید ناموفق", value: search.query.status });
          this.params[7].value = search.query.status;
        } else {
          this.params[7].options.push(
              { text: "انجام شده ها", value: "success" },
              { text: "انجام نشده ها", value: "failed" },
              { text: "ترنسفر جدید", value: "core" },
              { text: "ترنسفر جدید لغو شده", value: "corecanceled" },
          )
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
     loadedBalanceSam() {
      this.$store.dispatch(GET_BANK_LIST).then(loadedBankList => {
        loadedBankList.forEach((element, index) => {
          httpHelper
            .getData(`sharing/get_balance/${element.title}`)
            .then((res) => {
              if (!res.result.url.match("https://")) {
                this.totlaBalanc += res.result.balance;
                this.params[index].value =
                  Number(res.result.balance).toLocaleString() + " ریال";
              } else {
                this.$makeToast(
                  "danger",
                  "مشاهده موجودی بانک ملی",
                  "برای مشاهده موجودی اینجا کلیک کنید.",
                  7000,
                  res.result.url
                );
              }
            });
        });
      });
    },
    change(e) {
      if (e === "success") {
        const index = this.fields
          .map((obj) => {
            return obj.key;
          })
          .indexOf("btns");
        this.fields.splice(index, 1);
      } else {
        this.fields.push({ key: "btns", label: "حذف" });
      }
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "لیست تسویه های تسهیم" }]);
    this.loadedBalanceSam();
  },
};
</script>
